import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { addRowToGoogleSheet } from './api';
import './Invitation.css';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export const Invitation = ({ isOpened }) => {
  const query = useQuery();
  const token = query.get('token');
  let decodedToken = '';
  let guestNames = [];
  try {
    decodedToken = token ? atob(token) : '';
    guestNames = decodedToken.split('&');
  } catch (e) {
    decodedToken = '';
  }

  const [guests, setGuests] = useState(guestNames.length);
  const [iGuest, setIGuest] = useState(1);
  const [selections, setSelections] = useState([]);
  const [showRSVP, setShowRSVP] = useState(false);
  const [responded, setResponded] = useState(false);
  useEffect(() => {
    const flip = () => setShowRSVP((prev) => isOpened && !prev);
    window.addEventListener('click', flip);

    return () => {
      window.removeEventListener('click', flip);
    };
  }, [isOpened]);

  const changeGuests = (num) => {
    if (num < 0) setGuests(0);
    else if (num > 4) setGuests(4);
    else setGuests(num);

    if (iGuest > num) setIGuest(num);
    if (num === 1) setIGuest(1);
  };

  const selectOption = (guest, option) => {
    const newSelections = [...selections];
    newSelections[guest] = option;
    setSelections(newSelections);
  };

  const respond = async () => {
    const name = guestNames.join(" & "); // Replace with actual name if needed
    const now = new Date().toLocaleString();
    if (guests === 0) {
      await addRowToGoogleSheet({
        date: now,
        name,
        guest: 0,
        food: "Not attending"
      });
    } else {
      for (let i = 1; i <= guests; i++) {
        const foodIdx = selections[i] || '';
        let food = '';
        if (foodIdx === 1) food = 'Trout with Mushroom Risotto';
        else if (foodIdx === 2) food = 'Chicken with Roasted Potatoes';
        else if (foodIdx === 3) food = 'Mushroom Ravioli (Vegetarian)';
        await addRowToGoogleSheet({
          date: now,
          name,
          guest: i,
          food
        });
      }
    }
    setResponded(true);
  };

  if(!decodedToken) return null;

  return (
    <>
      <div className={`container ${showRSVP ? 'show-rsvp' : ''}`}>
        <img src='invitation.png' alt='invitation' />

        <div className='invitation-text rsvp' onClick={(e) => e.stopPropagation()}>
          <span id="rsvp-title" className='text'>
            RSVP
          </span>
          <div id='guest-text'>
            <span className='text'>We would like</span>
            <div id='guest-num-container'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 640 640'
                onClick={() => changeGuests(guests + 1)}
              >
                <path d='M297.4 201.4C309.9 188.9 330.2 188.9 342.7 201.4L502.7 361.4C515.2 373.9 515.2 394.2 502.7 406.7C490.2 419.2 469.9 419.2 457.4 406.7L320 269.3L182.6 406.6C170.1 419.1 149.8 419.1 137.3 406.6C124.8 394.1 124.8 373.8 137.3 361.3L297.3 201.3z' />
              </svg>
              <span id='guest-num' className='text'>
                {' '}
                {guests}{' '}
              </span>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 640 640'
                onClick={() => changeGuests(guests - 1)}
              >
                <path d='M297.4 438.6C309.9 451.1 330.2 451.1 342.7 438.6L502.7 278.6C515.2 266.1 515.2 245.8 502.7 233.3C490.2 220.8 469.9 220.8 457.4 233.3L320 370.7L182.6 233.4C170.1 220.9 149.8 220.9 137.3 233.4C124.8 245.9 124.8 266.2 137.3 278.7L297.3 438.7z' />
              </svg>
            </div>
            <span className='text'>seats reserved</span>
          </div>

          {guests > 0 && (
            <>
              <span className='text'>With the following food selection:</span>
              <div id='guest-selector'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 640 640'
                  onClick={() => setIGuest((prev) => (prev <= 1 ? 1 : prev - 1))}
                >
                  <path d='M201.4 297.4C188.9 309.9 188.9 330.2 201.4 342.7L361.4 502.7C373.9 515.2 394.2 515.2 406.7 502.7C419.2 490.2 419.2 469.9 406.7 457.4L269.3 320L406.6 182.6C419.1 170.1 419.1 149.8 406.6 137.3C394.1 124.8 373.8 124.8 361.3 137.3L201.3 297.3z' />
                </svg>

                <span className='text'>Guest {iGuest} of {guests}</span>

                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 640 640'
                  onClick={() => setIGuest((prev) => (prev >= guests ? guests : prev + 1))}
                >
                  <path d='M439.1 297.4C451.6 309.9 451.6 330.2 439.1 342.7L279.1 502.7C266.6 515.2 246.3 515.2 233.8 502.7C221.3 490.2 221.3 469.9 233.8 457.4L371.2 320L233.9 182.6C221.4 170.1 221.4 149.8 233.9 137.3C246.4 124.8 266.7 124.8 279.2 137.3L439.2 297.3z' />
                </svg>
              </div>

              <div className='option' onClick={() => selectOption(iGuest, 1)}>
                <OptionIcon selected={selections[iGuest] === 1} />
                <span className='text'>Trout with Mushroom Risotto</span>
              </div>

              <div className='option' onClick={() => selectOption(iGuest, 2)}>
                <OptionIcon selected={selections[iGuest] === 2} />
                <span className='text'>Chicken with Roasted Potatoes</span>
              </div>

              <div className='option' onClick={() => selectOption(iGuest, 3)}>
                <OptionIcon selected={selections[iGuest] === 3} />
                <span className='text'>Mushroom Ravioli (Vegetarian)</span>
              </div>
            </>
          )}
          {responded ? (
            <span className="text" style={{marginTop: 16}}>Thank you for your response!</span>
          ) : (
            <button id="respond" className="text" onClick={respond}>Respond</button>
          )}
        </div>

        <div className='invitation-text'>
          {guestNames.length > 1 ? (
            <>
              <span className='invitee'>{guestNames[0]}</span>
              <span className='invitee'>and</span>
              <span className='invitee'>{guestNames[1]}</span>
            </>
          ) : (
            <>
              <span className="invitee" style={{ opacity: 0}}>&nbsp;</span>
              <span className="invitee solo">{guestNames[0]}</span>
            </>
          )}

          <span className='br' />
          <span className='text'>We invite you to share with us a celebration of love and commitment</span>
          <span className='br' />
          <span className='text'>September</span>
          <span className='text' style={{ marginRight: 33 }}>
            Wednesday <span className='date'>| 24 |</span> at 4 PM
          </span>
          <span className='text'>2025</span>
          <span className='br' />
          <span className='text'>Delta Hotels Victoria Ocean Pointe Resort</span>
          <span className='br' />
          <span className='vr'>Vira & Roman</span>
        </div>
      </div>
    </>
  );
};

const OptionIcon = ({ selected }) => {
  if (selected) {
    return (
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 640 640'>
        <path d='M64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576C178.6 576 64 461.4 64 320z' />
      </svg>
    );
  }

  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 640 640'>
      <path d='M528 320C528 205.1 434.9 112 320 112C205.1 112 112 205.1 112 320C112 434.9 205.1 528 320 528C434.9 528 528 434.9 528 320zM64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576C178.6 576 64 461.4 64 320z' />
    </svg>
  );
};